<template>
  <div class="customer-navigation">
    <div class="customer-navigation__links">
      <LinkButton
        :tag="route.path === '/' ? 'span' : 'nuxt-link'"
        to="/"
        text-neutral
        class="customer-navigation__link text--primary text--bold"
      >
        Telekom Zubehörshop
      </LinkButton>

      <LinkButton
        tag="a"
        class="customer-navigation__link"
        href="https://geschaeftskunden.telekom.de/"
        rel="noopener"
        target="_blank"
        text-neutral
        is-external
      >
        Geschäftskunden
      </LinkButton>
    </div>
    <div class="customer-navigation__links">
      <LinkButton
        tag="a"
        class="customer-navigation__link"
        href="https://www.telekom.de/telekom-shops"
        rel="noopener"
        target="_blank"
        text-neutral
        is-external
      >
        Telekom Shops
      </LinkButton>
      <LinkButton
        tag="a"
        class="customer-navigation__link"
        href="https://www.telekom.de/kontakt"
        rel="noopener"
        target="_blank"
        text-neutral
        is-external
      >
        Kontakt
      </LinkButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';
import { useRoute } from '#imports';

const route = useRoute();
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.customer-navigation {
  padding-top: $grid-base * 0.5;
  padding-bottom: $grid-base;
  margin-bottom: $grid-base * -0.5;
  padding-left: $grid-base;
  display: flex;
  justify-content: space-between;
  transition: opacity 0.4s $nav-timing-function;
  opacity: 1;

  @include mq(false, $mq-lg - 1) {
    display: none;
  }

  @include mq($mq-lg) {
    padding-left: $grid-base * 1.5;
  }

  &__links {
    @include font-size(12px, 14px);
    display: flex;
    gap: 2 * $grid-base;
  }
}

body.nav-scrolled {
  .customer-navigation {
    @include mq($mq-lg) {
      opacity: 0;
    }
  }
}

body.nav-scrolled--complete {
  .customer-navigation {
    @include mq($mq-lg) {
      visibility: hidden;
    }
  }
}
</style>
